import { Link } from 'react-router'
import { Logo } from '@/components/Logo'
import { Container } from '@/components/layout'
import { site } from '@/lib/site'
import { SECONDARY_NAV } from './navigation'

export function SiteFooter() {
  return (
    <footer className="mt-16 border-t border-white/70 bg-subtle/60 sm:mt-24">
      <Container className="grid gap-10 py-10 sm:py-12 md:grid-cols-[1.4fr_repeat(3,1fr)]">
        <div className="space-y-4">
          <Logo />
          <p className="max-w-sm text-sm leading-relaxed text-muted-foreground">
            Iniciativa cívica independente e apartidária, sem vínculo com governos, partidos ou candidaturas.
          </p>
          <p className="max-w-sm text-sm leading-relaxed text-muted-foreground">
            As votações são consultas abertas, de participação espontânea: não são pesquisas representativas da
            população e não têm efeito eleitoral ou legislativo.
          </p>
        </div>
        {/* No celular, essas páginas ficam no menu "Mais" da navegação inferior. */}
        {SECONDARY_NAV.map((column) => (
          <nav key={column.title} aria-label={column.title} className="hidden space-y-3 md:block">
            <h2 className="text-sm font-semibold">{column.title}</h2>
            <ul className="space-y-2">
              {column.links.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-muted-foreground hover:text-foreground hover:underline">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        ))}
      </Container>
      <div className="border-t border-white/70">
        <Container className="flex flex-col gap-2 py-6 text-xs text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} Poder Aberto. Proponha. Questione. Participe.</p>
          <p className="flex gap-4 md:hidden">
            <Link to="/termos" className="hover:text-foreground hover:underline">
              Termos de Uso
            </Link>
            <Link to="/privacidade" className="hover:text-foreground hover:underline">
              Privacidade
            </Link>
          </p>
          <p>
            Contato:{' '}
            <a href={`mailto:${site.contactEmail}`} className="hover:text-foreground hover:underline">
              {site.contactEmail}
            </a>
          </p>
        </Container>
      </div>
    </footer>
  )
}
